import { Controller, useFormContext, useFieldArray, useWatch } from 'react-hook-form';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import * as S from './FileInput.styled';

interface IProps {
  name: string;
}

export const FileInput = ({ name }: IProps) => {
  const { control, trigger } = useFormContext();

  const { append } = useFieldArray({
    control,
    name,
  });

  const file = useWatch({
    control,
    name,
  });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <S.Container>
          <S.AvatarWrapper>
            <UploadFileIcon />
          </S.AvatarWrapper>
          <S.UploadLabelWrapper>
            <S.UploadLabel htmlFor={name}>Click to upload</S.UploadLabel>
            <S.UploadText>or drop and drop</S.UploadText>
          </S.UploadLabelWrapper>
          <S.Description>{file.length > 0 ? file[0].name : 'PDF (max. 3MB each)'}</S.Description>
          <S.Input
            id={name}
            type="file"
            accept="application/pdf, .doc, .docx, image/png, image/jpg"
            {...field}
            value=""
            onChange={(e) => {
              if (e.target.files?.length && e.target.files.length > 0) {
                append(e.target.files[0]);
                trigger(name);
              }
            }}
          />
        </S.Container>
      )}
    />
  );
};
